/* eslint-disable space-before-function-paren */
/*
 * @Author: MWeiLiu
 * @Date: 2019-12-17 20:16:27
 * @Last Modified by: MWeiLiu
 * @Last Modified time: 2021-04-06 20:21:26
 */

// import Conf from './config'

// const service = require('../../assets/js/request')
// const env = process.env

class Common {
  /** 路由管理
   *
   * @static
   * @param {*} option
   * @returns
   * @memberof Common
   */
  static routeManagement(option) {
    var conf = {
      code: 1,
      msg: ''
    }

    let userinfo = localStorage.getItem('userinfo')
    if (!userinfo || userinfo === '') {
      // 是否存在
      if (option.to.name && (this.inArray(option.to.name, option.guard.need) > -1 ||
          this.inArray(option.to.name, option.guard.unwante) > -1 ||
          this.inArray(option.to.name, option.guard.public) > -1)) {
        // 没有登录
        if (this.inArray(option.to.name, option.guard.need) > -1) {
          conf.msg = '请先登录'
          conf.code = -1
          alert(conf.msg)
        }
      } else {
        conf.code = 404
        conf.msg = '您访问的页面不存在'
      }
    } else {
      // 是否存在
      if (option.to.name && (this.inArray(option.to.name, option.guard.need) > -1 ||
          this.inArray(option.to.name, option.guard.unwante) > -1 ||
          this.inArray(option.to.name, option.guard.public) > -1)) {
        // 已登录
        if (this.inArray(option.to.name, option.guard.unwante) > -1) {
          conf.code = 0
        } else {
          conf.code = 1
          conf.msg = '欢迎回来'
        }
      } else {
        conf.code = 404
        conf.msg = '您访问的页面不存在'
      }
    }
    return conf
  }

  /**
   * 查询数组中的字符
   *
   * @static
   * @param {*} str
   * @param {*} arr
   * @returns
   * @memberof Common
   */
  static inArray(str, arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === str) {
        return i
      }
    }
    return -1
  }
  /**
   * // 验证表单
   * @param {Object} info
   * @param {Function} cb
   */
  static verification(info, cb = null, target) {
    if (this.isEmpty(info)) {
      target.$Toast('表单内容不能为空')
    } else {
      if (this.isExistEmpty(info)) {
        target.$Toast('表单内存在非法空格')
      } else {
        if (info.phone && !this.checkPhone(info.phone)) {
          target.$Toast('请填写正确的手机号')
        } else if (info.email && !this.isEmail(info.email)) {
          target.$Toast('请填写合法的邮箱')
        } else {
          cb()
        }
      }
    }
  }
  /**
   * // 判断字符是否为空的方法
   * @param {*} obj
   */
  static isEmpty(obj) {
    var regu = '^[ ]+$'
    var re = new RegExp(regu)
    for (var item in obj) {
      if (typeof obj[item] === 'undefined' || obj[item] == null || obj[item] === '' || re.test(obj[item])) {
        return true
      }
    }
    return false
  }
  /**
   * 手机号验证规则
   * @param {num} phone
   */
  static checkPhone(phone) {
    if (!(/^1[3456789]\d{9}$/.test(phone))) {
      return false
    } else {
      return true
    }
  }

  /**
   * 功能: 检查Email地址的正确性
   * @param {boolean} strEmail  boolean类型,  true = 合法 email,  false = 错误email
   */
  static isEmail(strEmail) {
    var e = strEmail.replace(/^\s*|\s*$/g, '')
    // eslint-disable-next-line no-useless-escape
    var emailReg = /^[\w-\._]*[\w]@[\w][\.\w-]*[\w]\.[a-z]+$/i
    var p = e.indexOf('@')
    if (emailReg.test(e) && e.indexOf('..') < 0 && e.indexOf('@', p + 1) < 0) {
      return true
    } else {
      return false
    }
  }
  /**
   * // 判读只能字符串中是否存在空白字符
   * @param {*} str
   */
  static isExistEmpty(obj) {
    for (var item in obj) {
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      if (obj[item] === '' || re.test(regu)) {
        return true
      }
    }
    return false
  }
}

export default Common



// WEBPACK FOOTER //
// ./src/assets/js/common.js